import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { referralFormDefault } from "@factory/form/form.default";
import { ReferralFormRule, ReferralFormSchema } from "@factory/form/form.rule";
import { useQyCreateReferral } from "@factory/query/referral.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewReferral() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateReferral } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Referral is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addReferral, isLoading: isCreating } =
    useQyCreateReferral(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<ReferralFormSchema>({
    defaultValues: referralFormDefault,
    resolver: zodResolver(ReferralFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: ReferralFormSchema) => {
    const formData = mapCreateReferral(form);
    addReferral(formData);
  };
  const handleValidateError = (err: FieldErrors<ReferralFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
